export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Risparmio Energetico',
      description: 'Materiali e soluzioni innovative per ottimizzare i consumi energetici e ridurre i costi operativi delle strutture industriali e commerciali.',
      features: ['Audit energetici', 'Isolamento termico', 'Sistemi di efficientamento']
    },
    {
      icon: 'ri-sun-line',
      title: 'Pannelli Fotovoltaici',
      description: 'Progettazione, fornitura e installazione di impianti fotovoltaici per la produzione di energia pulita da fonti rinnovabili.',
      features: ['Impianti residenziali', 'Impianti industriali', 'Manutenzione']
    },
    {
      icon: 'ri-recycle-line',
      title: 'Energie Rinnovabili',
      description: 'Sistemi integrati per la produzione di energia da fonti rinnovabili, conformi alle normative vigenti e agli incentivi statali.',
      features: ['Solare termico', 'Pompe di calore', 'Accumulo energia']
    },
    {
      icon: 'ri-building-2-line',
      title: 'Strutture in Ferro',
      description: 'Progettazione e realizzazione di strutture metalliche per applicazioni industriali, commerciali e infrastrutturali.',
      features: ['Carpenteria metallica', 'Strutture portanti', 'Coperture industriali']
    },
    {
      icon: 'ri-tools-line',
      title: 'Forniture Industriali',
      description: 'Fornitura di materiali e componenti per il settore edile e industriale, con supporto tecnico specializzato.',
      features: ['Materiali certificati', 'Logistica integrata', 'Consulenza tecnica']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Supporto Tecnico',
      description: 'Assistenza tecnica qualificata per la progettazione, installazione e manutenzione di impianti e strutture.',
      features: ['Progettazione', 'Installazione', 'Manutenzione']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-6">
            <span className="text-sm font-semibold text-emerald-700">I Nostri Servizi</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Soluzioni Complete per il <strong>Risparmio Energetico</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Offriamo servizi integrati per il <strong>risparmio energetico</strong>, <strong>pannelli fotovoltaici</strong> e <strong>strutture industriali</strong>, adattati alle specifiche esigenze dei clienti
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-xl mb-6 group-hover:bg-emerald-600 transition-colors">
                <i className={`${service.icon} text-3xl text-emerald-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-emerald-600"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-base text-gray-700 mb-6">
            Hai bisogno di una soluzione personalizzata per il <strong>risparmio energetico</strong>?
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-emerald-600 text-white rounded-lg text-base font-semibold hover:bg-emerald-700 transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
          >
            Richiedi una Consulenza Gratuita
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
